export default __webpack_public_path__ + "static/favicon-d86b5f51fdb749adcef0d66078c78879.ico";